import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import Draggable from 'vuedraggable';
import Condition from './Condition.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ConditionSortableList',
    props: {
        modelValue: {
            type: Array,
            default: () => []
        }
    },
    emits: ["update:modelValue", "edit", "delete"],
    setup(__props) {
        return (_ctx, _cache) => {
            return (__props.modelValue.length)
                ? (_openBlock(), _createBlock(_unref(Draggable), {
                    key: 0,
                    "model-value": __props.modelValue,
                    class: "flex flex-col border border-gray-400",
                    handle: ".drag-btn",
                    "item-key": "id",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update:modelValue', $event)))
                }, {
                    item: _withCtx(({ element }) => [
                        _createVNode(Condition, {
                            condition: element.condition ? element.condition.name : '',
                            stage: element.stage ? element.stage.name : '',
                            location: element.anatomy ? element.anatomy.name : '',
                            status: element.status,
                            presence: element.is_present,
                            differential: element.is_differential,
                            class: "border-b border-gray-300",
                            onEdit: ($event) => (_ctx.$emit('edit', element)),
                            onDelete: ($event) => (_ctx.$emit('delete', element.id))
                        }, null, 8, ["condition", "stage", "location", "status", "presence", "differential", "onEdit", "onDelete"])
                    ]),
                    _: 1
                }, 8, ["model-value"]))
                : _createCommentVNode("", true);
        };
    }
});
